import { defaultSetter }             from 'rewire-common';
import DataQueries                   from '../graphql/Queries';
import groupDialogModel              from '../schedule/GroupDialogModel';
import mainPageModel                 from '../main-navigation/MainPageModel';
import { MasterDataSettingsModel }   from './MasterDataSettingsModel';
import { IEditPanelView }            from './SettingsModel';
import archiveDeleteGroupDialogModel from './ArchiveDeleteGroupDialogModel';
import GroupEditPanelView            from './GroupEditPanelView';
import { GroupSort }                 from '../DataTypes';

const GroupSchema = `
  id
  code
  name
  tags
  fields
  archived
  area {
    id
    name
  }
`;

export default class GroupsSettingsModel extends MasterDataSettingsModel {
  getArea(v: any): string {
    return `Area: ${v.area?.name}`;
  }

  constructor() {
    super('Group', 'groups', groupDialogModel, [
      { label: 'Area', get: (v: any) => this.getArea(v), set: defaultSetter('Area') },
    ]);

    this.EditPanelView = GroupEditPanelView as IEditPanelView;;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddGroups;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditGroups;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteGroups;
  }

  protected async _load(filter: {search?: string}, sort?: GroupSort) {
    const results = (await DataQueries.getGroups(GroupSchema, filter, sort, this.paging.itemsPerPage, this.paging.currentPage));
    this.setItems(results.data);
    return results;
  }

  archive = async () => {
    archiveDeleteGroupDialogModel.load(this.selectedItem, 'archive');
  };

  handleArchiveOnSubmit = () => {
    this.paging.load(true);
  };

  removeItem = async () => {
    if (!this.selectedItem) return;
    archiveDeleteGroupDialogModel.load(this.selectedItem, 'delete');
  };

  handleDeleteOnSubmit = () => {
    const selectedIdx = this.state.items.findIndex(i => i.id === this.selectedItem.id);
    if (selectedIdx >= 0) this.state.items.splice(selectedIdx, 1);
    this._selectItem(undefined);
  };

  activate() {
    const isActive = this.isActive;
    super.activate();
    if (!isActive) {
      archiveDeleteGroupDialogModel.onEvent.addListener('archive', this.handleArchiveOnSubmit);
      archiveDeleteGroupDialogModel.onEvent.addListener('delete', this.handleDeleteOnSubmit);
    }
  }

  deactivate() {
    const isActive = this.isActive;
    super.deactivate();
    if (isActive) {
      archiveDeleteGroupDialogModel.onEvent.removeListener('archive', this.handleArchiveOnSubmit);
      archiveDeleteGroupDialogModel.onEvent.removeListener('delete', this.handleDeleteOnSubmit);
    }
  }
}
